import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isActiveDelegation: false,
    currentDelegation: null,
}

const delegationSlice = createSlice({
    name: 'delegation',
    initialState,
    reducers: {
        fetchingDelegationSuccess: (state, action) => {
            state.isActiveDelegation = true;
            state.currentDelegation = action.payload;
        },
        fetchingDelegationReset: (state) => {
            state.isActiveDelegation = false;
            state.currentDelegation = null;
        },
    }
});

export const { fetchingDelegationSuccess, fetchingDelegationReset } = delegationSlice.actions;

export default delegationSlice.reducer;